"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EquipYourVision() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.4;
  return <section className="relative h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1417410/img/earth_mountains_sand_plant_loading_trucks.png)",
      transform: `translateY(${parallaxOffset}px)`,
      willChange: "transform"
    }}>
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      {}
      <div ref={contentRef} className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center">
        {}
        <h1 className={`mb-4 font-display text-5xl font-bold text-white transition-all duration-700 ease-out md:text-6xl lg:text-7xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
        transitionDelay: "200ms"
      }}>
          Equipa Tu Visión
        </h1>

        {}
        <p className={`mb-8 max-w-2xl text-lg text-white/90 transition-all duration-700 ease-out md:text-xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
        transitionDelay: "400ms"
      }}>
          Somos una compañía especializada en la comercialización de camiones, máquinas y equipos para que realices tus proyectos con el respaldo de ProGroup.
        </p>

        {}
        <div className={`absolute bottom-8 flex flex-col items-center gap-2 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
        transitionDelay: "800ms"
      }}>
          <span className="text-xs font-medium uppercase tracking-wider text-white/70">
            DESPLÁZATE PARA DESCUBRIR
          </span>
          <div className="h-12 w-6 rounded-full border-2 border-white/30 p-1">
            <div className="animate-bounce-slow h-2 w-2 rounded-full bg-white/70" />
          </div>
        </div>
      </div>
    </section>;
}